/**
 * Fester Kurzcode im QR-Code und Stammplatz auf dem Etikett (ADR 0013 §12,
 * ADR 0017).
 *
 * Im QR-Code eines Lagerorts steht `BASIS_ADRESSE/l/<kurzcode>`. Der Kurzcode
 * aendert sich nie -- die Kennung darf es. `/l/<x>` loest trotzdem auch die
 * Kennung auf, damit Etiketten von vor dem Kurzcode weiter funktionieren.
 *
 * Rein, wie alles hier: Server und Geraet loesen gleich auf und drucken
 * dasselbe.
 */
/** Die Adresse im QR-Code: `https://wawi.example/l/K7M2Q`. */
export function lagerortAdresse(basis, kurzcode) {
    return `${basis.replace(/\/+$/, "")}/l/${kurzcode}`;
}
/**
 * Einen Lagerort ueber das finden, was hinter `/l/` steht.
 *
 * Erst der Kurzcode, dann die Kennung -- beides ohne Ruecksicht auf Gross- und
 * Kleinschreibung. Dass eine Kennung einem fremden Kurzcode gleicht, verhindert
 * die Pflege; kaeme es doch vor, gewinnt der Kurzcode, denn er steht auf dem
 * neueren Etikett.
 */
export function lagerortNachCode(orte, code) {
    const gesucht = code.trim().toUpperCase();
    if (gesucht === "")
        return null;
    let perKennung = null;
    for (const o of orte) {
        if (o.kurzcode?.toUpperCase() === gesucht)
            return o;
        if (perKennung === null && o.kennung.toUpperCase() === gesucht)
            perKennung = o;
    }
    return perKennung;
}
/** Tiefer sind Stammdaten nicht -- und ein Kreis darf nicht haengen. */
const PFAD_GRENZE = 12;
/**
 * Der Stammplatz als Weg von oben: `["HALLE", "R-02", "T7-F1"]`.
 *
 * Feste Orte haengen fest, ihr Weg bleibt richtig, solange keiner die
 * Stammdaten umbaut. Ein Packstueck dagegen wandert: Der Weg hoert an ihm auf.
 * Ein Geraet mit Stammplatz GB-01 bekommt also „GB-01“, nicht den Platz, an
 * dem die Kiste heute steht. Ein Fach in einer Kiste wird „WK-03 › OBEN“.
 */
export function stammplatzPfad(id, orte) {
    const pfad = [];
    let aktuell = id;
    const gesehen = new Set();
    while (aktuell !== null && !gesehen.has(aktuell) && pfad.length < PFAD_GRENZE) {
        gesehen.add(aktuell);
        const ort = orte.get(aktuell);
        if (ort === undefined)
            break;
        pfad.unshift(ort.standardziel ? ort.bezeichnung : ort.kennung);
        if (ort.artikel_id !== null)
            break;
        aktuell = ort.eltern_id;
    }
    return pfad;
}
/** Trenner zwischen den Stufen eines Wegs. */
export const PFAD_TRENNER = " › ";
/**
 * Kuerzt einen Weg, bis er passt: erst die Mitte weg („HALLE › … › T7-F1“),
 * dann der Anfang („… › T7-F1“). Das Ende bleibt immer -- es ist der Platz
 * selbst. Passt auch das nicht, kommt es ungekuerzt zurueck, und der Aufrufer
 * schneidet ab.
 */
export function pfadKuerzen(pfad, passt) {
    const ganz = pfad.join(PFAD_TRENNER);
    if (pfad.length <= 1 || passt(ganz))
        return ganz;
    const erstes = pfad[0] ?? "";
    // Von hinten so viele Stufen, wie mit dem Anfang davor passen.
    for (let hinten = pfad.length - 2; hinten >= 1; hinten -= 1) {
        const text = [erstes, "…", ...pfad.slice(-hinten)].join(PFAD_TRENNER);
        if (passt(text))
            return text;
    }
    const letztes = pfad.at(-1) ?? "";
    const nurEnde = ["…", letztes].join(PFAD_TRENNER);
    return passt(nurEnde) ? nurEnde : letztes;
}
//# sourceMappingURL=kurzcode.js.map